import { HTTP } from '@/services/axios';

export async function getAccessRightsOptions(){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: '/app/core/AccessRights/getAccessRightsOptions.php',
    })
    .then(response => {
        result = response.data;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}